// extracted by mini-css-extract-plugin
module.exports = {"main":"global_main__3WGXh","onboarding":"global_onboarding__2rbVe"};